module.exports = __webpack_public_path__ + "img/7_39.032d1ac7.png";